import type { Library } from "@/types/api";

/**
 * pluginLibraryUIURL returns the plugin UI that a plugin-provided pseudo-library
 * should open (served over the reverse tunnel), or null for ordinary filesystem
 * libraries — which route to the standard library page. A plugin pseudo-library
 * has no files to browse, so selecting it must open the plugin's own UI.
 */
export function pluginLibraryUIURL(lib: Library): string | null {
  if (lib.attributes.source_kind === "plugin" && lib.attributes.ui_url) {
    return lib.attributes.ui_url;
  }
  return null;
}

/**
 * pluginEmbedPath maps a plugin's backend UI URL (/plugins/{id}/...) to the
 * SPA route that renders it inside the app shell (/apps/{id}/...), keeping
 * the sidebar and theme around plugin pages. Non-plugin URLs pass through
 * unchanged (callers fall back to a plain link).
 */
export function pluginEmbedPath(uiURL: string): string {
  if (uiURL.startsWith("/plugins/")) {
    return "/apps/" + uiURL.slice("/plugins/".length);
  }
  return uiURL;
}
